export var SrciEventTypeEnumsObj = {
    SDK_INITIALIZE_STARTED: "SDK_INITIALIZE_STARTED",
    SDK_INITIALIZE_SUCCESS: "SDK_INITIALIZE_SUCCESS",
    SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE: "SDK_INITIALIZE_FAIL_DEVICE_NOT_ELIGIBLE",
    SDK_REINITIALIZE_STARTED: "SDK_REINITIALIZE_STARTED",
    SDK_REINITIALIZED: "SDK_REINITIALIZED",
    SDK_INITIALIZE_ERROR: "SDK_INITIALIZE_ERROR",
    SDK_PARAMETERS_FAILED_VALIDATION: "SDK_PARAMETERS_FAILED_VALIDATION",
    BUTTON_RENDERED: "BUTTON_RENDERED",
    BUTTON_NOT_RENDERED_ALREADY_EXISTS: "BUTTON_NOT_RENDERED_ALREADY_EXISTS",
    BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR: "BUTTON_RENDER_FAIL_BUTTON_PARAMS_VALIDATION_ERROR",
    BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS: "BUTTON_RENDER_FAIL_BUTTON_CONTAINER_DOESNT_EXISTS",
    BUTTON_RENDER_FAIL_BUTTON_SDK_NOT_INITIALIZED_PROPERLY: "BUTTON_RENDER_FAIL_BUTTON_SDK_NOT_INITIALIZED_PROPERLY",
    GET_SRCI_PROFILE_STARTED: "GET_SRCI_PROFILE_STARTED",
    GET_SRCI_PROFILE_SUCCESS: "GET_SRCI_PROFILE_SUCCESS",
    GET_SRCI_PROFILE_ERROR: "GET_SRCI_PROFILE_ERROR",
    IDENTITY_LOOKUP_STARTED: "IDENTITY_LOOKUP_STARTED",
    IDENTITY_LOOKUP_SUCCESS: "IDENTITY_LOOKUP_SUCCESS",
    IDENTITY_LOOKUP_ERROR: "IDENTITY_LOOKUP_ERROR",
    OTP_SEND_STARTED: "OTP_SEND_STARTED",
    OTP_SEND_SUCCESS: "OTP_SEND_SUCCESS",
    OTP_SEND_ERROR: "OTP_SEND_ERROR",
    OTP_VALIDATION_STARTED: "OTP_VALIDATION_STARTED",
    OTP_VALIDATION_SUCCESS: "OTP_VALIDATION_SUCCESS",
    OTP_VALIDATION_ERROR: "OTP_VALIDATION_ERROR",
    RECOGNITION_TOKEN_STORAGE_SUCCESS: "RECOGNITION_TOKEN_STORAGE_SUCCESS",
    RECOGNITION_TOKEN_STORAGE_ERROR: "RECOGNITION_TOKEN_STORAGE_ERROR",
    DEVICE_READY_TO_PAY: "DEVICE_READY_TO_PAY",
    DEVICE_NOT_READY_TO_PAY: "DEVICE_NOT_READY_TO_PAY",
    PAYMENT_SHEET_RENDERED: "PAYMENT_SHEET_RENDERED",
    PAYMENT_SHEET_RENDER_FAIL_PARAMS_VALIDATION_ERROR: "PAYMENT_SHEET_RENDER_FAIL_PARAMS_VALIDATION_ERROR",
    PAYMENT_SHEET_RENDER_FAIL_CONTAINER_DOESNT_EXISTS: "PAYMENT_SHEET_RENDER_FAIL_CONTAINER_DOESNT_EXISTS",
    PAYMENT_SHEET_RENDER_FAIL_ALREADY_EXISTS: "PAYMENT_SHEET_RENDER_FAIL_ALREADY_EXISTS",
    PAYMENT_SHEET_CLOSED_BY_USER: "PAYMENT_SHEET_CLOSED_BY_USER",
    PAYMENT_SHEET_CLOSED_PURCHASE_DONE: "PAYMENT_SHEET_CLOSED_PURCHASE_DONE",
    PAYMENT_COMPLETION_STARTED: "PAYMENT_COMPLETION_STARTED",
    PAYMENT_COMPLETION_ERROR: "PAYMENT_COMPLETION_ERROR",
    PAYMENT_COMPLETION_OK: "PAYMENT_COMPLETION_OK",
    PAYMENT_COMPLETION_NOK: "PAYMENT_COMPLETION_NOK",
    PAYMENT_COMPLETION_REQUIRED_3DS: "PAYMENT_COMPLETION_REQUIRED_3DS",
    CARD_COUNTRY_NOT_ALLOWED: "CARD_COUNTRY_NOT_ALLOWED",
    CARD_TYPE_NOT_ALLOWED: "CARD_TYPE_NOT_ALLOWED",
    UNBIND_STARTED: "UNBIND_STARTED",
    UNBIND_OK: "UNBIND_OK",
    UNBIND_ERROR: "UNBIND_ERROR",
    UNEXPECTED_UI_ERROR: "UNEXPECTED_UI_ERROR",
};
